export const init = () => {
  if (document.querySelector('.b-manuals-selector')) {
    
  }
}